module.exports = __webpack_public_path__ + "img/PT264.0281693c.svg";